export const COLORS = {
    brand1: "#5bac23",
    brand2: "#96c872",
    brand3: "#b1d695",
    brand4: "#e6f1db",
    brand5: "#ffffff",
}